const screenSizeTypeMap = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl',
}

export default screenSizeTypeMap
